import React from "react";
import { Ticket, Eye, AlertTriangle, CheckCircle } from "lucide-react";

const SupportTickets = () => {
  const tickets = [
    {
      id: "TCK-001",
      customer: "Vishal Chaubey",
      category: "Payment Issue",
      priority: "High",
      message: "Payment deducted but order not placed.",
      date: "15 Nov 2025",
      status: "Open",
    },
    {
      id: "TCK-002",
      customer: "Rahul Sharma",
      category: "Order Delay",
      priority: "Medium",
      message: "Order not delivered on expected date.",
      date: "14 Nov 2025",
      status: "In Progress",
    },
    {
      id: "TCK-003",
      customer: "Priya Verma",
      category: "Return Request",
      priority: "Low",
      message: "Need help with product return.",
      date: "13 Nov 2025",
      status: "Closed",
    },
  ];

  return (
    <div className="p-4">
      {/* Page Title */}
      <h1 className="text-2xl font-bold mb-4 flex items-center gap-2">
        <Ticket /> Support Tickets
      </h1>

      {/* Tickets Table */}
      <div className="bg-white shadow rounded-xl p-4">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b">
              <th className="py-3">Ticket ID</th>
              <th className="py-3">Customer</th>
              <th className="py-3">Category</th>
              <th className="py-3">Priority</th>
              <th className="py-3">Message</th>
              <th className="py-3">Date</th>
              <th className="py-3">Status</th>
              <th className="py-3 text-right">Actions</th>
            </tr>
          </thead>

          <tbody>
            {tickets.map((t, index) => (
              <tr key={index} className="border-b last:border-none">
                <td className="py-3 font-medium">{t.id}</td>
                <td className="py-3">{t.customer}</td>
                <td className="py-3">{t.category}</td>

                {/* Priority Badge */}
                <td className="py-3">
                  {t.priority === "High" && (
                    <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm flex items-center gap-1 w-fit">
                      <AlertTriangle size={14} /> High
                    </span>
                  )}
                  {t.priority === "Medium" && (
                    <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-sm w-fit">
                      Medium
                    </span>
                  )}
                  {t.priority === "Low" && (
                    <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm w-fit">
                      Low
                    </span>
                  )}
                </td>

                <td className="py-3 text-gray-700">{t.message}</td>
                <td className="py-3">{t.date}</td>

                {/* Status Badge */}
                <td className="py-3">
                  {t.status === "Closed" ? (
                    <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm flex items-center gap-1 w-fit">
                      <CheckCircle size={14} /> Closed
                    </span>
                  ) : t.status === "In Progress" ? (
                    <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm w-fit">
                      In Progress
                    </span>
                  ) : (
                    <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-sm w-fit">
                      Open
                    </span>
                  )}
                </td>

                {/* Actions */}
                <td className="py-3 text-right flex justify-end gap-2">
                  <button className="flex items-center gap-1 bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg text-sm">
                    <Eye size={16} /> View
                  </button>

                  {t.status !== "Closed" && (
                    <button className="flex items-center gap-1 bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-lg text-sm">
                      <CheckCircle size={16} /> Close Ticket
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SupportTickets;
